import DesktopFilled from './src/desktop-filled';
export default DesktopFilled;